import { css, styled } from '@mui/material/styles';
import { Box, Button as Btn } from '@mui/material';

interface CriarMembroProps {
  disabled?: boolean;
}

export const Content = styled(Box)`
  width: 100%;
  .form-login {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    .inputMember-cel {
      width: 100%;
    }
  }

  .input-container {
    height: 42px;
    margin: 0px 20px 20px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .name-filter {
    width: 100%;
    height: 42px;
    border: 1px solid #4c4c4c;
    border-radius: 5px;

    padding: 8px 50px;
    opacity: 0.5;

    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    /* identical to box height, or 200% */

    display: flex;
    align-items: center;

    /* Grey/Off Black */

    color: #0e0e2c;
  }
`;

export const Section = styled(Box)`
  padding: 0px 20px 20px 20px;
  width: 100%;
  display: flex;
  flex-direction: column;

  .input {
    width: 100%;

    border-radius: 5px;
  }

  .input-permission {
    width: 100%;
    border: 1px solid #4c4c4c;
    border-radius: 5px;

    padding: 10px;
  }

  .btn-next {
    width: 100%;
    margin-top: 25px;
    display: flex;
    justify-content: end;
  }

  .label {
    padding: 0;
    margin: 0;
  }
`;

export const ButtonComponent = styled(Btn)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px 10px;

  width: 70px;
  height: 36px;

  border-radius: 4px;

  ${(props: CriarMembroProps) =>
    props.disabled &&
    css`
      background: rgba(0, 0, 0, 0.12);
    `}
`;

export const Typography = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 23px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`;

export const SectionHeaderDrawer = styled(Box)`
  display: flex;
  flex-direction: row;
  margin: 25px 20px 20px 20px;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;
`;
